import React, { Component } from 'react';

import Title from '../../components/Title';
import Conteudo from '../../Conteudo';

import ListaAchadosPerdidos from './ListaAchadosPerdidos';

export default class extends Component {
  render() {
    let { params: { id } } = this.props.match;
    return (<div>
        <Title value="Diego Rivera » Achados & Perdidos" />
        <Conteudo>
          <ListaAchadosPerdidos selected={id} />
          <br />
          Atenção: O conteúdo divulgado é de inteira responsabilidade de quem enviou.
        </Conteudo>
    </div>);
  }
}


// WEBPACK FOOTER //
// ./src/modules/achados/Index.js